<template>
    <cookie-law theme="base">
        <div slot-scope="props" class="w-full">
            <p class="xs:m-0 sm:m-0 text-gray-600 text-base text-center md:text-left">
                This site uses cookies as outlined in our <a v-bind:href="privacyUrl">Privacy Policy</a>

                <span class="block md:inline-block md:float-right mt-2 md:mt-0">
                    <button class="w-32 h-10 bg-green-500 hover:bg-green-700 border-green-500 hover:border-green-700 text-sm border-4 text-white py-1 px-2 rounded cursor-pointer" v-on:click="props.accept"><span>I accept</span></button>
                    <button class="w-32 h-10 bg-red-500 hover:bg-red-700 border-red-500 hover:border-red-700 text-sm border-4 text-white py-1 px-2 rounded cursor-pointer" v-on:click="props.close"><span>No thanks</span></button>
                </span>
            </p>
        </div>

    </cookie-law>
</template>

<script>
  import CookieLaw from 'vue-cookie-law';

  export default {
    props: ['privacyUrl'],
    components: { CookieLaw }
  }
</script>
